import React from "react"
import { Drawer } from "antd"
import { useLocation } from "react-router-dom"

const StoreDrawer = ({
  AllFilterOption,
  setCurrentPage,
  visible,
  onClose,
  stores,
  selectedStore,
  onSelectStore,
  title,
  highest_role,
  /** When set (e.g. from profile market admin), overrides JWT for picker UI */
  effectiveHighest,
  selectMerchant,
  setSelectMerchant,
  market_role,
}) => {
  const location = useLocation()
  const isStoresRoute = location.pathname.includes("stores")
  const isProductsRoute = location.pathname.includes("products")
  const isReadOnlyRole = market_role === "2" || market_role === "3"
  const drawerRole =
    effectiveHighest != null && String(effectiveHighest).trim() !== ""
      ? effectiveHighest
      : highest_role
  const showAllOption =
    drawerRole === "SUPERADMIN" || isReadOnlyRole || isProductsRoute

  const lang = localStorage.getItem("language") || "ar"

  return (
    <Drawer
      title={title}
      placement={lang === "ar" ? "left" : "right"}
      onClose={onClose}
      open={visible}
      width={440}
    >
      <div className="d-flex flex-wrap">
        {showAllOption && (
          <div
            className={` p-4 pointer ${
              lang === "ar" ? "ml-16" : "mr-16"
            } store-box`}
            onClick={() => {
              if (isStoresRoute) {
                setSelectMerchant && setSelectMerchant("")
              } else if (isProductsRoute) {
                onSelectStore && onSelectStore(null)
                setCurrentPage && setCurrentPage(1)
              } else {
                setSelectMerchant && setSelectMerchant("all")
              }
              setCurrentPage && setCurrentPage(1)
              onClose()
            }}
            style={{
              border: isStoresRoute
                ? !selectMerchant
                  ? "1px solid #FD853A"
                  : "1px solid #E8E8E8"
                : isProductsRoute
                ? !selectedStore
                  ? "1px solid #FD853A"
                  : "1px solid #E8E8E8"
                : selectMerchant === "all"
                ? "1px solid #FD853A"
                : "1px solid #E8E8E8",
              backgroundColor: isStoresRoute
                ? !selectMerchant
                  ? "rgba(253, 133, 58, 0.05)"
                  : "#FFFFFF"
                : isProductsRoute
                ? !selectedStore
                  ? "rgba(253, 133, 58, 0.05)"
                  : "#FFFFFF"
                : selectMerchant === "all"
                ? "rgba(253, 133, 58, 0.05)"
                : "#FFFFFF",
              cursor: "pointer",
            }}
          >
            <div className="d-flex flex-column align-items-center justify-content-center">
              <div className="text-12 text-center">All {AllFilterOption}</div>
            </div>
          </div>
        )}

        {stores.length > 0 &&
          stores?.map((store) => (
            <div
              key={store.id}
              className={` p-4 pointer ${
                lang === "ar" ? "child-mr-ar" : "child-mr-en"
              } store-box`}
              onClick={() => {
                onSelectStore && onSelectStore(store)
                setSelectMerchant && setSelectMerchant(store)
                setCurrentPage && setCurrentPage(1)
                onClose()
              }}
              style={{
                border:
                  (selectedStore?.id || selectMerchant?.id) === store.id
                    ? "1px solid #FD853A"
                    : "1px solid #E8E8E8",
                backgroundColor:
                  (selectedStore?.id || selectMerchant?.id) === store.id
                    ? "rgba(253, 133, 58, 0.05)"
                    : "#FFFFFF",
                cursor: "pointer",
              }}
            >
              <div className="d-flex flex-column align-items-center justify-content-center">
                {!(drawerRole === "SUPERADMIN" || isReadOnlyRole) && (
                  <div className="mb-14">
                    <img
                      src={store.logo || "/icons/default-store.svg"}
                      alt={store.name}
                      width={30}
                      height={36}
                    />
                  </div>
                )}

                <div className="text-12 text-center">
                  {(lang === "ar"
                    ? store.store_name_arabic
                    : store.store_name) || store.name_english}
                </div>
              </div>
            </div>
          ))}
      </div>
    </Drawer>
  )
}

export default StoreDrawer
